// Phase 6 — React glue around the TickController.
//
// Owns the controller's lifecycle: starts on mount, stops on unmount.
// Every successful tick updates the store via `setClassified`, which is
// where `clockOffset` and `lastServerSeenAt` are derived. The store is
// the single source of truth; this hook does not keep its own copies.

import { useEffect } from 'react';
import { tick as tickApi } from '../api/client';
import { useAppStore } from '../state/store';
import { TickController } from './tickController';

export function useTickController(): void {
  useEffect(() => {
    const ctrl = new TickController({
      fetchTick: async (req) => tickApi(req),
      getInputs: () => {
        const s = useAppStore.getState();
        return {
          planToken: s.planToken,
          schedule: s.anchoredPlan?.schedule ?? [],
          completedTaskIds: s.completedTaskIds,
        };
      },
      onResponse: (res) => {
        useAppStore.getState().setClassified(res.classified, res.nudge, res.serverNow);
      },
      onError: () => {
        // Calm: no console.error — the offline chip handles the user-
        // facing surface. Errors are diagnosed via the lastServerSeenAt
        // gap (README §9 "silent for up to 60 s").
      },
    });
    ctrl.start();
    return () => ctrl.stop();
  }, []);
}
